import React, { useContext, useState } from "react";
import { useHistory } from "react-router-dom";
import { useQueryParams } from "utils/hooks/useQueryParams";
import axios from "axios";
import Email from "common/EmailV2";
import { BreakpointContext } from "components/common";
import { useQueryParamsAsJson } from "@tomocredit/common-fe/utils";
import { isValidEmail } from "@tomocredit/common-fe/utils/validation";
import { LEAD_SOURCES } from "@tomocredit/common-fe/consts/consts";
import {
  currMobileBrowserAccepted,
  fromWebview,
  isMobile,
  referralParam,
  utmParams,
} from "utils/userAgentInfo";
import {
  HeaderTextDesktop,
  BUSINESS_FUNDING,
  NO_CREDIT_NEEDED,
} from "./HeaderText";
import CheckMarkTexts from "./CheckMarkText";
import { BureauLogoDesktop } from "./BureauLogo";

const generateLoginLink = (queryParameters) => {
  return `${process.env.REACT_APP_DOMAIN}/dashboard/login${
    queryParameters.size ? `?${queryParameters.toString()}` : ""
  }`;
};

const LandingForm = () => {
  const { isBelow } = useContext(BreakpointContext);
  const belowMd = isBelow("md");
  const belowSm = isBelow("sm");
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const { capturedUrlParams, rawUrlParams } = useQueryParamsAsJson(["email"]);

  const withQueryParams = useQueryParams();

  const sendOldEmailVerification = !!(
    (isMobile() && (utmParams.source || !currMobileBrowserAccepted())) ||
    fromWebview
  );

  const handleSubmit = async (email) => {
    if (loading) {
      return;
    }
    setError(null);
    if (!email) {
      setError("Email address is required");
      return;
    }
    if (!isValidEmail(email)) {
      setError("Invalid email address");
      return;
    }
    setLoading(true);

    try {
      const userPayload = {
        withReferralCode: referralParam,
        sendOldEmailVerification,
        userId: email,
        utm: utmParams,
        source: LEAD_SOURCES.KOSMOFI_LANDING,
        capturedUrlParams,
      };
      await axios
        .post(
          `${process.env.REACT_APP_BACKEND_URL}/users/newUserFromLanding`,
          userPayload // eslint-disable-line comma-dangle
        )
        .then((data) => {
          const { boostEnrolled, softTerminated } = data?.data ?? {};
          if (boostEnrolled && !softTerminated) {
            rawUrlParams.set("email", email);
            window.location.assign(generateLoginLink(rawUrlParams));
            return;
          }
          history.push(withQueryParams("/boost-pricing", { email }));
        });
    } catch (err) {
      setError("Could not communicate with server. Please try again later");
      return;
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={`text-white px-6 ${belowSm ? "w-full" : ""}`}>
      {!belowMd && (
        <>
          <HeaderTextDesktop belowSm={belowSm} text={BUSINESS_FUNDING} />
          <HeaderTextDesktop belowSm={belowSm} text={NO_CREDIT_NEEDED} />
        </>
      )}
      {!belowMd && (
        <CheckMarkTexts
          className="py-2 text-lg md:text-2xl w-1/2"
          textClassName="my-4"
        />
      )}
      <div style={{ maxWidth: 393 }} className="mb-4">
        <Email
          buttonText="Get Started"
          handleSubmit={handleSubmit}
          componentClassName="flex-col sm:flex-row space-y-4 sm:space-y-0 mt-2"
          inputClassName="w-full rounded-md sm:rounded-r-none border border-neutral-500 sm:border-r-0 placeholder-gray-600 text-black bg-white"
          buttonClassName="bg-boost-button-purple text-white w-full sm:w-auto py-2 text-white rounded-md sm:rounded-l-none font-medium bg-black-bg hover:bg-neutral-600 active:bg-neutral-700 px-4 border border-boost-button-purple hover:border-neutral-600 active:border-neutral-700"
        />
        {error && (
          <p className="text-sm text-red-500 text-left mt-1">{error}</p>
        )}
      </div>
      {!belowMd && <BureauLogoDesktop />}
    </div>
  );
};

export default LandingForm;
